import { render, staticRenderFns } from "./PermissionGuard.vue?vue&type=template&id=0ff49243&scoped=true&"
import script from "./PermissionGuard.vue?vue&type=script&lang=js&"
export * from "./PermissionGuard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff49243",
  null
  
)

export default component.exports